import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import styles from "./index.module.css";

/*
 * Item displaying information for the report table
 */
export default function ReportItemBreakout({
  item,
  isOdd,
  type,
  allColumns = [],
  groupedTotalPercent = 30,
  groupedColumnsCount = null,
}) {
  return (
    <div className={classNames(styles.iboItem, isOdd && styles.odd)}>
      <div
        className={styles.ibo}
        style={{
          fontWeight: type === "total" ? "bold" : "normal",
        }}
      >
        {item.IBO}
      </div>
      <div className={styles.lastName}>{item.lastName}</div>
      <div className={styles.displayName}>{item.displayName}</div>
      <div className={styles.pin}>{item.pin}</div>
      <div className={styles.email}>{item.email}</div>
      <div className={styles.topicsId}>{item.topicsId}</div>
      <div className={styles.diamond}>{item.diamond}</div>
      <div className={styles.attending}>{item.attending}</div>
      <div className={styles.qGroups}>
        {item.qGroups.map(
          (group, index) =>
            group + (index < item.qGroups.length - 1 ? ", " : "")
        )}
      </div>

      {allColumns.map((col, index, arr) => {
        const colCount = arr.length;
        const totalGrouped = groupedColumnsCount || colCount;
        const colWidth = groupedTotalPercent / totalGrouped;

        const match = (item.columns || []).find(
          (c) => c.name === col.name && c.headerName === col.headerName
        );
        const value = match ? match.value : "";
        const isWholeNumber = Number.isInteger(col.sort);

        return (
          <div
            key={`${col.name}-${value}-${index}`}
            className={index % 2 !== 0 ? styles.col : styles.oddCol}
            style={{
              width: `${colWidth}%`,
              // fontWeight: isWholeNumber ? "bold" : "normal",
              // borderLeft: isWholeNumber ? "1px solid #000" : "none",
              // justifyContent: isWholeNumber ? "center" : "left",
            }}
          >
            {value == 0 ? "" : value}
          </div>
        );
      })}
    </div>
  );
}

ReportItemBreakout.propTypes = {
  item: PropTypes.object,
  isOdd: PropTypes.bool,
  type: PropTypes.string,
};
